var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn mb-2 mr-2",class:_vm.getClassStr(),on:{"click":function($event){_vm.field.value = !_vm.field.value}}},[_vm._v(" "+_vm._s(_vm.field.question)+" ")]),(_vm.field.description)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.description)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }